import { useState } from "react";
import PropTypes from "prop-types";
import ErrorPopupBtn from "components/alert-popup/ErrorPopupBtn";
import { ErrorPopup } from "components/alert-popup/ErrorPopup";

// Standalone EOS error dot (no field label): for review rows
// (need/qualif cards) already flagged in red, it carries the explanatory tooltip
// instead of a separate red message.
const FafErrorDot = ({ label, errorMessage }) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <span className="faf-error-dot">
      <ErrorPopupBtn setShowErrorPopup={setShowPopup} />
      {showPopup && (
        <ErrorPopup
          label={label}
          errorMessage={errorMessage}
          showErrorPopup={showPopup}
          setShowErrorPopup={setShowPopup}
        />
      )}
    </span>
  );
};

FafErrorDot.propTypes = {
  label: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
  }).isRequired,
  errorMessage: PropTypes.string,
};

export default FafErrorDot;
